import { getAppField, hasAppValue } from './applicationFields';

export const HIRED_REQUIREMENT_DEFS = [
  {
    key: 'sss',
    label: 'SSS ID / Number',
    check: (app) => hasAppValue(getAppField(app, ['sss_file', 'sss_number', 'sssNumber', 'sss_num', 'sss'], '')),
  },
  {
    key: 'philhealth',
    label: 'PhilHealth ID / Number',
    check: (app) => hasAppValue(getAppField(app, ['philhealth_file', 'philhealth_number', 'philHealthNumber', 'phil_health_number'], '')),
  },
  {
    key: 'pagibig',
    label: 'Pag-IBIG ID / Number',
    check: (app) => hasAppValue(getAppField(app, ['pagibig_file', 'pagibig_number', 'pagIbigNumber', 'pag_ibig_number'], '')),
  },
  {
    key: 'tin',
    label: 'TIN / BIR ID',
    check: (app) => hasAppValue(getAppField(app, ['tin_file', 'tin_number', 'tinNumber', 'tin_num', 'tin'], '')),
  },
  {
    key: 'nbi',
    label: 'NBI Status / Clearance',
    check: (app) => {
      const nbiStatus = getAppField(app, ['nbi_status', 'nbiStatus', 'nbi_status_description'], '');
      const hasFile = hasAppValue(getAppField(app, ['nbi_file', 'nbi_files'], ''));
      if (!hasFile && !hasAppValue(nbiStatus)) return false;
      if (typeof nbiStatus === 'string' && nbiStatus.toLowerCase().includes('no nbi clearance')) return false;
      return true;
    },
  },
  {
    key: 'coe',
    label: 'Certificate of Employment or Previous Employer Clearance',
    check: (app) => hasAppValue(getAppField(app, ['coe_file', 'clearance_file', 'coe_or_clearance', 'clearance_and_coe'], '')),
  },
  {
    key: 'birth',
    label: 'Birth Certificate',
    check: (app) => hasAppValue(getAppField(app, ['birth_cert_file', 'birth_cert_files', 'birth_certificate_file'], '')),
  },
  {
    key: 'resume',
    label: 'Resume / CV',
    check: (app) => hasAppValue(getAppField(app, ['resume_file', 'resume_files', 'resume'], '')),
  },
];

export const getHiredRequirementStatus = (app) =>
  HIRED_REQUIREMENT_DEFS.map((def) => ({
    key: def.key,
    label: def.label,
    complete: def.check(app),
  }));

export const getPendingHiredRequirements = (app) =>
  getHiredRequirementStatus(app).filter((item) => !item.complete);
